export default __webpack_public_path__ + "static/hatla2ee-white-2c98f73d6a53f7b09ec51f98f8302336.png";